import { getApiUrl } from 'modules/Url';

export async function cancelUpload({ requestUuid }: { requestUuid: string }) {
  try {
    const resp = await fetch(
      getApiUrl({
        path: `upload/${requestUuid}/cancel`,
        queryParameters: {
          useAuthV3: true,
        },
      }),
      {
        method: 'POST',
        credentials: 'same-origin',
      }
    );
    if (resp.ok) {
      return resp.json();
    }
    throw new Error('Could not cancel upload');
  } catch (e) {
    throw new Error(e.message);
  }
}
